import React, { useState } from "react";
import { apiUrl } from "../services/requests";

const EnviarImagem = ({ img, setImg }) => {
  const [imagemInicial] = useState(`${apiUrl}/images/0.png`);

  return (
    <div className="max-w-36 max-h-48 rounded-2xl mt-1">
      <input
        className="z-10 relative bottom-6 opacity-0 w-full h-48"
        type="file"
        name="imagem"
        onChange={(e) => setImg(e.target.files[0])}
      />
      {img ? (
        <img
          className="z-0 relative bottom-6 -mt-48 w-full h-[185px] rounded-xl"
          src={URL.createObjectURL(img)}
          alt="imagem"
        />
      ) : (
        <img
          className="z-0 relative bottom-6 -mt-48 min-w-full min-h-full rounded-xl"
          src={imagemInicial}
          alt="imagem"
        />
      )}
    </div>
  );
};

export default EnviarImagem;
